<script>
    import FileUpload from "../../FileUpload";
    export default {
        name: "FileUpload",
        extends: FileUpload
    }
</script>